/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";

// Interactive Component Imports
import Loading from "../../../../Components/Interactive/Loading";

// MUI Imports
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

// Inner JSX Imports
import EmailLogsTable from "./EmailLogs/EmailLogsTable";

const CustomerEmailLogWidget = ({
  allCustomerData,
  loading,
  setUpdatedData,
  setTrigger,
}) => {
  const [open, setIsOpen] = useState(true);
  const [toggleDropdown, setToggleDropdown] = useState(true);

  const {
    userEmailNotesInfo: { emailNotes },
    userDetailsInfo: { customerId },
  } = allCustomerData;

  // Send account verification email
  const sendAccountVerify = async () => {
    const options = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        CustomerId: customerId
      }),
    };
    const res = await fetch(`/api/customer/${customerId}/send-account-verify`, options);
    const { success, message } = await res.json();
    setUpdatedData((prevState) => ({
      updateData: {
        ...prevState.updateData,
        state: success ? true : false,
        message: success ? "Email Sent Successfully" : message,
      },
    }));
    setTrigger("UPDATE_EMAILS");
    setTrigger("");
  };

    // Manually verify the customer's email
    const manualVerifyEmail = async () => {
      const options = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          CustomerId: customerId
        }),
      };
      const res = await fetch(`/api/customer/${customerId}/verify-email`, options);
      const { success, message } = await res.json();
      setUpdatedData((prevState) => ({
        updateData: {
          ...prevState.updateData,
          state: success ? true : false,
          message: success ? "Successful Manual Email Verification" : message,
        },
      }));
      setTrigger("UPDATE_USER_DETAILS");
    };

  return (
    <div className="user-data-container" style={{marginBottom: "1rem"}}>
      <div className="customer-widget-header">
        <p
          className="customer-widget-heading"
          style={{ width: "100%", padding: ".5rem .5rem" }}
        >
          Customer Email Log
        </p>
          {emailNotes && emailNotes.length >= 0 && (
            <div>
            {open && (
              <div className="verify-btns">
                <button
                className="manual-verify-btn moveRight"
                onClick={() => manualVerifyEmail()}
              >
                <span style={{color: "#fff"}}>Manually Verify Email</span>
              </button>
              <button
                className="add-note-btn-open moveRight"
                onClick={() => sendAccountVerify()}
              >
                <span style={{color: "#fff"}}>Send Code</span>
              </button>
              </div>
            )}
          </div>
          )}
          <ArrowDropDownIcon
              onClick={() => {
                setIsOpen(!open);
                setToggleDropdown(!toggleDropdown);
              }}
              className={`arrow-dropdown ${
                toggleDropdown ? "arrow-open" : "arrow-close"
              }`}
          />
      </div>
      <div>
        <div
          className={` ${open ? "show-data-table-call" : "no-data-table-call"}`}
        >
          {loading && <Loading />}
          {emailNotes && emailNotes.length >= 0 && (
            <EmailLogsTable
              emailLogs={emailNotes}
              open={open}
              allCustomerData={allCustomerData}
              setUpdatedData={setUpdatedData}
              setTrigger={setTrigger}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomerEmailLogWidget;
